// Data validation utilities for message fields
import * as Yup from "yup";

// Utils
import {
  messagesTypeFields,
  variableNameRegex,
} from "Components/Users/Admin/Common/MessageSettings";

const MIN_VARIABLE_COUNT = 4;
const MAX_EN_CHAR_COUNT = 400;
const MAX_FR_CHAR_COUNT = 600;

// Helper to count characters
const characterCount = (str) =>
  (str || "").replace(variableNameRegex, "").length;

const variableCount = (str) => {
  if (!str) return 0;
  const matches = str.match(variableNameRegex);
  return matches ? matches.length : 0;
};

const variableCheckFields = [
  "bookingConfirmation",
  "patientReschedule",
  "clinicReschedule",
];

const messageFieldSchemaWithVars = Yup.object({
  en: Yup.string()
    .required("English message is required")
    .test(
      "max-words-en",
      `English message must be 1 to ${MAX_EN_CHAR_COUNT} words`,
      (value) => characterCount(value) <= MAX_EN_CHAR_COUNT
    )
    .test(
      "min-variables-en",
      `English message must contain at least ${MIN_VARIABLE_COUNT} variables`,
      (value) => variableCount(value) >= MIN_VARIABLE_COUNT
    ),
  fr: Yup.string()
    .required("French message is required")
    .test(
      "max-words-fr",
      `French message must be 1 to ${MAX_FR_CHAR_COUNT} words`,
      (value) => characterCount(value) <= MAX_FR_CHAR_COUNT
    )
    .test(
      "min-variables-fr",
      `French message must contain at least ${MIN_VARIABLE_COUNT} variables`,
      (value) => variableCount(value) >= MIN_VARIABLE_COUNT
    ),
});

const messageFieldSchemaNoVars = Yup.object({
  en: Yup.string()
    .required("English message is required")
    .test(
      "max-words-en",
      `English message must be 1 to ${MAX_EN_CHAR_COUNT} words`,
      (value) => characterCount(value) <= MAX_EN_CHAR_COUNT
    ),
  fr: Yup.string()
    .required("French message is required")
    .test(
      "max-words-fr",
      `French message must be 1 to ${MAX_FR_CHAR_COUNT} words`,
      (value) => characterCount(value) <= MAX_FR_CHAR_COUNT
    ),
});

export const messagesTypesShape = {};
messagesTypeFields.forEach((field) => {
  messagesTypesShape[field.id] = variableCheckFields.includes(field.id)
    ? messageFieldSchemaWithVars
    : messageFieldSchemaNoVars;
});
